require('slick-carousel');

$(document).ready(function () {

    if ($('.image-slider').length > 0) {
        var settings = {
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 710,
            mobileFirst: true,
            dots: true,
            arrows: true
        }
        var sl = $('.image-slider').slick(settings);
    }
});